import React from 'react'
import Link from '../ui/link'

interface Props {
  tagCategories?: {
    label: string | null
    landingTags: {
      label: string | null
      slug: string | null
    }[]
  }[]
}

const TagCategories: React.FC<Props> = ({ tagCategories = [] }) => {
  if (!tagCategories || tagCategories.length === 0) {
    return null
  }

  const orderedTagCategories = tagCategories
    .filter(({ landingTags }) => landingTags.length > 0)
    .sort((a, b) => b.landingTags.length - a.landingTags.length)

  return (
    <section className="py-4 my-24 border-t border-gray-300 b lg:py-8 md:py-6 text-night">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {orderedTagCategories?.map(({ label, landingTags }) => (
          <div key={`${label}`} className="space-y-2">
            <h5 className="text-xl font-medium lg:text-2xl">{label}</h5>
            <ul className="flex flex-wrap">
              {landingTags?.map(({ label: tagLabel, slug }) => (
                <li key={`${tagLabel}`} className="my-1 mr-1">
                  <Link to={`/${slug}`} title={tagLabel || undefined}>
                    <p className="px-1.5 py-0.5 text-sm text-center text-gray-800 transition-colors duration-300 ease-in-out border border-gray-800 lg:text-base hover:border-primary hover:bg-primary-50 hover:text-primary rounded-xl">
                      {tagLabel}
                    </p>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}

export default TagCategories
